import { render } from "./TestPage4.vue?vue&type=template&id=7b96569d&scoped=true"
import script from "./TestPage4.vue?vue&type=script&lang=js"
export * from "./TestPage4.vue?vue&type=script&lang=js"

import "./TestPage4.vue?vue&type=style&index=0&id=7b96569d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b96569d"]])

export default __exports__